import { z } from "zod";

export const baseApiResponseError = z.record(z.string()).or(z.string().array()).optional();

export type BaseApiResponseError = z.infer<typeof baseApiResponseError>;

export const baseApiResponse = z.object({
	code: z.number().optional(),
	data: z.object({
		errors: baseApiResponseError,
		result: z.boolean()
	}),
	status: z.enum(["success", "error"])
});

export type BaseApiResponse = z.infer<typeof baseApiResponse>;

export const strKeyAnyValResolver = z.record(z.string(), z.any());
export type StrKeyAnyValModel = z.infer<typeof strKeyAnyValResolver>;
